export default "__VITE_ASSET__07430d3d__"